/*============================================================================
  UI
==============================================================================*/

function cartDrawerDisplay() {
    $('.backdrop').fadeIn();
    $('#cartWindow').addClass('open');
    $('html').css('overflow','hidden'); 
}

$('.openWindow').click(function(e) {
    e.preventDefault(); 
    //alert('clicked');
    var target = $('#' + $(this).attr('data-target'));
    target.addClass('open');
    if(target.hasClass('cart-window-container') || $(this).hasClass('purchase-window-button') || $(this).hasClass('choose-btn')) {
      $('html').css('overflow','hidden');
    }
});

/* Begin journey button */
let choose = document.querySelector('.openJourney');
if (choose) {
  choose.addEventListener("click", (event) => {
    event.preventDefault();
    document.getElementById(choose.dataset.target).classList.add('open');
    $('html').css('overflow','hidden');
    $('.backdrop').fadeIn();
  });
}

/* Back button for upload & summary screens */
$('.screen-back').click(function(e) {
    e.preventDefault(); 
    var target = $('#' + $(this).attr('data-target'));
    $(this).parents('.screen-window-container').removeClass('open');
    target.addClass('open');
});

/*============================================================================
  ADD TO CART SERIALIZE SIMPLE FORM
==============================================================================*/
/* Ths function is used when there's no options form associated */
function cartFormSerialize(form) {
    $.post("/cart/add.js", 
      form.serialize(),
      function(data, status, jqXHR) {
      },"json")  
      .done(function() {

        /* Update cart datas */
        getCart();
        /* Cases for display */
        //1- if there is a screen for upsell to show
        if($('body').hasClass('withUpScreen')) {
          $('.side-window').removeClass('open');
          $('.defaultUpsell').addClass('open');
        }
        //2 - if there isn't and open cart window (< v2) or cart page (>= v2) or display quick add confirmation (>= v3)
        else {
          /* Cases : we are on product template or cart page, we go to cart page, we are on other pages, we display notification */
          if($('body').hasClass('template-cart') || $('body').hasClass('template-product'))  {
            //cartDrawerDisplay();
            var linkCart = document.querySelector('body').dataset.cart;
            window.location = linkCart;
          } else {
            manageNotification(form);
            //alert('added to cart');
            //console.log(form.parent('.quick-add-form').attr('data-compare'));
          }
        } 
        $('#error422Product, #errorVariantProduct').fadeOut();

      })
     .fail(function(data, status, jqXHR) {
      if (data.status == '422' || data.status == '404') $('#error422Product').fadeIn(600);
      if(data.status == '400') $('#errorVariantProduct').fadeIn(600);
        //console.log(data.status);
    })
}


/*============================================================================
  NOTIFICATION MANAGER WHEN QUICK ADD USED
==============================================================================*/

var stopHidingNotif = ''; 
function manageNotification(form) {

  /* Retrieve datas to display for new product added */
  var notifDatas = form.parent('.quick-add-form'),
      notifTitle = notifDatas.attr('data-title'),
      notifPrice = notifDatas.attr('data-price'),
      notifCompare = notifDatas.attr('data-compare'),
      notifImg = notifDatas.attr('data-thumb');

  /* Check if sales price and set value */
  if (notifCompare == 'false') {
    var finalNotifPrice = '<span class="notif-price">' + notifPrice + '</span>';
  } else {
    var finalNotifPrice = '<span class="notif-sales-price sales-price"><strike>' + notifCompare + '</strike></span><span class="notif-price price">' + notifPrice + '</span>' ;   
  }

  /* Insert added product datas */
  /* Show image when new src is available */
  $('#notifImg').attr('src',notifImg).fadeIn('slow');
  $('#notifName').html(notifTitle);
  $('#notifPrice').html(finalNotifPrice);

  
  $('#quickAddNotif').addClass('open');

  stopHidingNotif = setTimeout(closeNotification, 4500);
}

function closeNotification() {
  $('#quickAddNotif').removeClass('open');
  /* HIde old image for next notification */
  $('#notifImg').fadeOut('slow');
  $('#notifImg').fadeOut('slow');
}

function closeNotificationBtn() {
    $('.closeNotif').click(function (e) {
    $('#quickAddNotif').removeClass('open');
    /* HIde old image for next notification */
    $('#notifImg').fadeOut('slow');
    $('#notifImg').fadeOut('slow');
  });
}

closeNotificationBtn();


/*============================================================================
  ADD TO CART WITH OPTIONS AND PROPERTIES
==============================================================================*/
/* This function is used when there's options to add to cart */

function optionsManager() {

  /* Init objects */
  var items = [],
      mainProps = {},
      optionsHandles = '',
      optionsID = '';

  /* Init global var for package */
  var package = $('#optionsList').attr('data-package');

  /* Define if product has options */
  var n = $('#optionsList input.optional-input:not(.ux-only):checked').length;
  if (n > 0) {
    var value = 'true';
    mainProps['_withOptionText'] = $('.withOption:checked').attr('data-text');
  } else {
    var value = 'false';
    mainProps['_noOptionText'] = $('#noOption').val();
  }
  
  /* Add info about option status to main product props */
  mainProps['_options'] = value;

  /* Browse options attached to main product */
  $($('#optionsList input.optional-input:checked').get().reverse()).each(function(index) {

    var name = $(this).attr('data-in-name'),
        value = $(this).attr('data-in-value'),
        handle = $(this).attr('data-handle');

    console.log(handle);
    mainProps[name] = value;
    optionsHandles = optionsHandles + ' # ' + handle;
    
    var variantID = parseInt($(this).attr('data-id')),
        qty = parseInt($(this).attr('data-qty')),
        price = $(this).attr('data-price'),
        propTitle = $(this).attr('data-prop-title'),
        propValue = $(this).attr('data-prop-value'),
        propAssociated = $(this).attr('data-main-handle'),
        propAssociatedID = $(this).attr('data-main-id'),
        propAssociatedsku = $(this).attr('data-sku');

    /* Add real product only if price is greater than 0 */
    if(price > 0) {      
      optionsID = optionsID + variantID + ',';      
      var item = {'id': variantID,'quantity': qty,properties:{'_type': 'optionProduct', '_package_id': package, [propTitle]: propValue, '_associated':propAssociated, '_parentID':propAssociatedID, '_ratio':qty}}      
      items.push(item);
    }
    console.log(items);
  });
  
  mainProps['_optionsHandles'] = optionsHandles;
  var finalOptionsID = '[' + optionsID.slice(0, -1) + ']';
  mainProps['_optionsID'] = finalOptionsID,
  mainProps['_package_id'] = package;

  /* Ajout éventuel des propriétés d'ordonnance jointe si existent et si doivent être affichées pour cette option */
  var ukContainer = document.querySelector('.uploadkit');
  if (ukContainer && $('.fileAttached').is(":checked")) {
    var ukConfirmText = ukContainer.dataset.propConfirm;
    var ukLinkText = ukContainer.dataset.propLink;
    var ukYes = ukContainer.dataset.propYes;
    var ukNo = ukContainer.dataset.propNo;
    /* Find input generated by UploadKit */
    var ukField = document.querySelector('.uploadkit .uploadkit-attribute-container input');
    var optionField = document.querySelector('.fileAttached');
    if (ukField && optionField.checked) {
      /* Props if field exists */
      mainProps[ukConfirmText] = ukYes;
      mainProps[ukLinkText] = ukField.value;
    } else {
      /* Props if field doesn't exist */
      mainProps[ukConfirmText] = ukNo;
    }
  } /*else {alert('condition no remplie pour upload');}*/


  /* Check variant id form case */
  var mainID = $(".product-form-container input[name=id]").val();

  /* Then push main product to items object */
  var mainItem = {'id': mainID, 'quantity': 1, properties:mainProps};

  items.push(mainItem);

  let formData = {
   'items': items
  };

  $.post("/cart/add.js", 
    formData,
    function(data, status, jqXHR) {
    },"json")  
    .done(function() {
      //console.log('added');

        /* Update cart datas */
        getCart();
        /* Cases for display */
        //1- if there is a screen for upsell to show
        if($('body').hasClass('withUpScreen')) {
          $('.side-window').removeClass('open');
          $('.defaultUpsell').addClass('open');
        }
        //2 - if there isn't and if that's not cart page, then open cart window
        else {
          //if(!$('body').hasClass('template-cart')) cartDrawerDisplay();
          if(!$('body').hasClass('template-cart'))  {
            var linkCart = document.querySelector('body').dataset.cart;
            window.location = linkCart;
          }          
        } 
        $('#error422Product, #errorVariantProduct').fadeOut();

      /* Réinit form add to cart (price and checkboxes) */
      // Not useful for V3, as redirect to cart page user leaves the page automatically
      //reinitAddForm();

    })
    .fail(function(data, status, description, jqXHR) {
      if (data.status == '422' || data.status == '404') $('#error422Product').fadeIn(600);
      if(data.status == '400') $('#errorVariantProduct').fadeIn(600);
      console.log(data.status);
  })

}


/*============================================================================
  PRICE CALCULATOR
==============================================================================*/

function calcProductPrice() {
    var price = parseInt($('.btnPrice').attr('data-init-price'));    
    //alert($(this).attr('data-qty'))
    $('#optionsList input.optional-input:not(.ux-only):checked').each(function(index) {
      price = price + (parseInt($(this).attr('data-price')))*parseInt($(this).attr('data-qty'));
    });
    $('.btnPrice').text(formattedPrice(price));  
}


/*============================================================================
  SCREEN MANAGERS
==============================================================================*/

/* Manage exceptions when specific options are selected */
function exceptionsManager() {  
    $('#optionsList input.optional-input:not(.ux-only):checked').each(function(index) {
      if($(this).attr('data-exception') == 'true') {

        /* Manage prev and next buttons on previous and next screen of skipped screen */
        var targetNext = $('#' + $(this).attr('data-previous'));
        var targetPrev = $('#' + $(this).attr('data-next'));
        var next = targetNext.find('.next-btn');        
        var previous = targetPrev.find('.screen-back');
        next.attr('data-target',$(this).attr('data-next'));
        previous.attr('data-target',$(this).attr('data-previous'));

        /* Manage end of the journey display with add to cart on previous screen if skipped screen is the last one */
        if(targetPrev.length == 0) {
          activateSubmit(next);
        }        

      } else {
        /* Reverse if user has selected new option which is not an exception and there is no skipped screen */
        var nextButton = $('#' + $(this).attr('data-target-next')).find('.next-btn'),
            prevButton = $('#' + $(this).attr('data-target-previous')).find('.screen-back'),
            screenToDisplay = $(this).attr('data-skipped');
        nextButton.attr('data-target',screenToDisplay);
        prevButton.attr('data-target',screenToDisplay);

        /* Unless default btn is set to submit, redisplay next button */
        if(!$('#' + $(this).attr('data-target-next')).hasClass('defaultSubmit'))
          activateNextScreen(nextButton);
      }
    });  
}

/* Manage next screen and prev screen for choices */
function setNextScreen(elem) {
  var next = elem.attr('data-next');
  if (next != 'cart') {    
    var newTarget = 'screen' + next,
        newPrev = 'screen' + elem.attr('data-current'),
        prevNewTarget = $('#' + newTarget).find('.screen-back');    

    /* Update current screen next button amongst params set by user for this choice */  
    nextBtns = elem.parents('.screen-window-container').find('.next-btn')
    nextBtns.attr('data-target', newTarget);

    /* Update next screen previous button target with current screen id */
    prevNewTarget.attr('data-target', newPrev);
  }

}

function activateNextScreen(elem) {
  elem.parents('.screen-window-container').find('.next-container').addClass('grid').removeClass('hide-content');
  elem.parents('.screen-window-container').find('.submit-container').addClass('hide-content').removeClass('grid');
}

function activateSubmit(elem) {
  elem.parents('.screen-window-container').find('.submit-container').removeClass('hide-content').addClass('grid');
  elem.parents('.screen-window-container').find('.next-container').addClass('hide-content').removeClass('grid'); 
}


/*Manage screen display */
function screenManager() {
  $('.next-btn,.screen-back').click(function(e) {
    var close = $('#' + $(this).attr('data-current'));
    close.removeClass('open');
  });
}

/* Manage pre-check of the first option or reset */
function preCheckManager() {

  /* When click next check first option of the targeted screen */
  $('.next-btn').click(function(e) {

      /* Exec only if user hasn't yet selected an option AND MOBILE ONLY */
      //if (window.innerWidth <= 769) {
        var targetScreen = $('#' + $(this).attr('data-target'));
        targetScreen.find('.option-list').find('input:first').prop('checked',true);
      //}

      /* Check exceptions */
      exceptionsManager();      

      /* Recalculate price with current preselected options with a slight delay during window animation */
      setTimeout(() => {calcProductPrice();}, 300); 
  });

  /* When click previous uncheck option of current screen */
  $('.screen-back').click(function(e) {    

    var targetScreen = $(this).attr('data-current');
    $('#' + targetScreen + ' .option-list .optional-input').prop('checked',false);

    /* Recalculate price with current preselected options with a slight delay during window animation */
    setTimeout(() => {calcProductPrice();}, 300);

    /* Check exceptions */
    exceptionsManager();     
  });

}

function reinitAddForm() {
  /* Choices back to default */
  $('.choiceCustom').prop('checked',false);
  $('.choiceBasic').prop('checked',true);
  /* Uncheck Options */
  $('.option-list .optional-input').prop('checked',false);

  /* Manage color display default active product view */
  $('.color-screen-options-container .colorOptionLink').removeClass('active');
  $('.color-screen-options-container .colorOptionLink').first().addClass('active');
  $('.colorOptionVariants').removeClass('flex').addClass('hide-content');
  $('.colorOptionVariants').first().addClass('flex').removeClass('hide-content');

  /* Reinit Price calc */
  calcProductPrice();  
  /* Activate first submit */
  activateSubmit($('.choiceBasic'));
}

function clearPrevChoices() {
  /* If user choose new choice (parcours), then clear previous selected options (variants)*/
  $('.options-list :radio').prop('checked',false);  
}

/*============================================================================
  COLOR OPTION MANAGER
==============================================================================*/

function colorListener() {
  $('.colorOptionLink').click(function(e) {

    e.preventDefault();

    $('.colorOptionLink').removeClass('active');
    $(this).addClass('active');

    var target = '#' + $(this).attr('data-target');
    $('.colorOptionVariants').addClass('hide-content').removeClass('flex');
    $(target).removeClass('hide-content').addClass('flex');
  })
}

/*============================================================================
  OPTIONAL PRODUCT WITH MULTIPLE OPTIONS FOR VARIANTS MANAGER IN SCREENS
==============================================================================*/

function screenVariants() {
  $('.option-values--value').on('click', function() {
    var selectVariantID = '#';
    $('.screen-window-container.open .option-values--value input:checked').each(function(index) {
      var thisVal = $(this).attr('data-value');
      //$(this).parent().css('color','red');
      //console.log(thisVal);
      selectVariantID = selectVariantID + thisVal;      
    });    

    selectVariantID = selectVariantID.replace(/\s/g,'');
    console.log(selectVariantID);

    $('.option-list .variant-block')/*.addClass('hide-content')*/.prop('checked', false);

    if ($(selectVariantID).length) {
    $('.screen-window-container.open .unavailable-variant-message').addClass('hide-content');    
      $('.screen-window-container.open ' + selectVariantID)/*.removeClass('hide-content')*/.find('input').prop('checked', true);
    } else {
      $('.screen-window-container.open .unavailable-variant-message').removeClass('hide-content');
    }
    calcProductPrice();
    
  });  
}



/*============================================================================
  SUBMIT FORM MANAGER
==============================================================================*/
function cartFormManager() {
  /* Check if uploadKit screen exists and store info if it is */
  var uploadStatus = false;
  var uploadScreen = document.querySelector('.defaultUpload');
  if (uploadScreen) uploadStatus = true; 

  /* Check if accessory screen exists and store info if it is */
  var upStatus = false;
  let upScreen = document.querySelector('.defaultUpsell');
  if(upScreen) $('body').addClass('withUpScreen');

  /* Check if summary screen exists and store info if it is */
  var summaryStatus = false;
  let summaryScreen = document.querySelector('.defaultUpsell');
  if (summaryScreen) summaryStatus = true; 

  /* Then proceed to add to cart actions */
  $('form .cart-btn:not(#QuickAdd)').click(function(e) {
    e.preventDefault();    

    /* Check if checked choice necessitates to show upload screen */  
    var choice = $('.withOption:not(.ux-only):checked');   
    var uploadChoice = choice.attr('data-upload');   
    
    if (choice.is(':checked')) {

      //if (uploadStatus && !$('.defaultUpload').hasClass('open') && uploadChoice == 'true') {
        /* Check if uploadKit exists and is not current screen, if it does then show upload Screen */
        //$('.defaultSubmit ').removeClass('open');     
        //$('.defaultUpload').addClass('open');     
      //} else if (summaryStatus && !$('.defaultSummary').hasClass('open')) {
        //$('.defaultSubmit').removeClass('open');     
        //$('.defaultSummary').addClass('open');  
      //} else {
        /* If uploadKit does not exist or is current screen or not required, then add to cart with options */
        optionsManager();
      //}
    } else {
     /* If no option activated by user then simply add to cart */
     var thisForm = $(this).parents('form');
     cartFormSerialize($(thisForm));
   }
  }); 
  
  $('#mainContent').on('click', 'form .upsell-add,.quick-add-form .quick-add-btn,#QuickAdd,.cart-free-product--add button, .promoCardForm button, cardsimulator button', function(e){ 
      e.preventDefault();     
      /* Close previous notification */
      $('#quickAddNotif').removeClass('open');
      /* Clear timeout */
      clearTimeout(stopHidingNotif);
      /* Hide previous image to replace it with new product image */
      $('#notifImg').fadeOut('slow');       
      var thisForm = $(this).parents('form');
      cartFormSerialize($(thisForm));
  });
}


/*============================================================================
  OPTION CHECK LISTENERS
==============================================================================*/

function enableOption() {
  $('.withOption').prop('disabled',false);
}

/* Listen to check actions then update datas */
function priceListener() {  
  $('#optionsList :radio').click(function() {
    calcProductPrice();
    exceptionsManager();
  });
}

/* Listen to variant selection in options */
function optionListener() {
  $('.options-list :not(.ux-only):radio').click(function() {
    /* Check if next screen needed if not then add to cart automatically - DESKTOP ONLY */
    //if(window.innerWidth > 769) {
      //var nextElem = $(this).parents('.screen-window-container').find('.next-container');
      //if(nextElem.hasClass('hide-content')) {
        /* if ready to add to cart, then do */
        //document.getElementById('AddToCart').click();
      //} else {
        /* if not, redirect to next step automatically */
        //nextElem.find('.next-btn').click();
      //}
    //}
  });
}

/* Listen to type of choice selection then update display and direct to next screen if needed - DESKTOP AND MOBILE */
function choiceListener() {
  $('.choices-list :radio').click(function() {
    /* 1ST CLEAR PREV OPTIONS SELECTED */
    clearPrevChoices();

    /* 2 THEN CHECK CHOICE TYPE */
    if($(this).hasClass('choiceBasic')) {
      /* Display add to cart button at the bottom of the screen */
      activateSubmit($(this));
      /* Then click to add which will trigger a automatic redirect to cart page once added */
      document.getElementById('AddToCart').click();
    } else {
      /* Show next button */
      activateNextScreen($(this)); 
      /* Update next target if needed */
      setNextScreen($(this));      
      /* CLICK TO GO TO NEXT SCREEN if needed*/      
      $(this).parents('.screen-window-container').find('.next-container .next-btn').click();
    }
  });  
}


function uploadShower() {
  $('.showUpload').click(function (e) {
    $('.uploadkit').fadeIn();
  });
  $('.hideUpload').click(function (e) {
    $('.uploadkit').fadeOut();
  });
}


/*============================================================================
  SUMMARY PAGE MANAGEMENT
==============================================================================*/

function updateSummary(elem) {
  var currentWindow = elem.closest('.screen-window-container');

  var variantsTarget = document.querySelector('.summary-variants');
  variantsTarget.innerHTML = '';

  var variantTitle = document.querySelector('.summary-title-variant');
  var variantPrice = document.querySelector('.summary-price-variant');

  if (currentWindow.classList.contains('color-screen')) {

    var selectedVariant = currentWindow.querySelector(':checked');
    var selectedOption = currentWindow.querySelector('.optional-input-color:checked + .color-option-block .variant-option--name').textContent;
    var selectedVariantTitle = selectedVariant.dataset.inName;
    
    variantTitle.textContent = selectedVariantTitle;
    variantsTarget.innerHTML = selectedOption;
    variantPrice.textContent = selectedVariant.dataset.priceMoney;

  } else {
    var selectedOptions = currentWindow.querySelectorAll('.ux-only:checked + .radio-label .variant-block-title');
  
    var selectedVariant = currentWindow.querySelector('.optional-variant:checked');

    variantTitle.textContent = selectedVariant.dataset.inName;

    variantPrice.textContent = selectedVariant.dataset.priceMoney;

    for (var i = 0; i < selectedOptions.length; i++) {
        const node = document.createElement("option");
        const textnode = document.createTextNode(selectedOptions[i].textContent.trim());
        node.appendChild(textnode);
        variantsTarget.appendChild(node);
    }
  }

  var uploadTarget = document.querySelector('.summary-title-upload');
  uploadTarget.textContent = document.querySelector('.defaultUpload input:checked').value;;
}

function summaryManager() {
  var btns = document.getElementsByClassName('updateSummary');
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function (e) {
      updateSummary(this);
    });
  }
  var uploadWindow = document.querySelector('.defaultUpload');      
    uploadWindow.querySelector('.next-btn').addEventListener("click", function (e) {
      /* Find inputs generated by UploadKit */
      var ukField = document.querySelector('.uploadkit .uploadkit-attribute-container input');
      var optionField = document.querySelector('.fileAttached');
      if (ukField && optionField.checked) {
        document.querySelector('.summary-title-upload').textContent = document.querySelector('.uploadkit-button-uploaded').textContent;
      } else {
        document.querySelector('.summary-title-upload').textContent = document.querySelector('.hideUpload input').value;
      }
    });
  //alert(selectedUpload);

}

/*============================================================================
  MAIN VARIANT MANAGER
==============================================================================*/

function listenVariants() {
  $('.option-value').on("click", function() {
    if(!$(this).hasClass('active')) {

      /* First unselect other option buttons then activate this */
      $(this).parents('.option-container').find('.option-value.active').removeClass('active');
      $(this).addClass('active');

      /* Then update elems for availability, price, accordion variables datas and cart form */
      variantStock();
      variantSelector();
    }
  });  
}

function variantSelector() {

  /* First build selected variant selector */
  var variantName = '';

  $('.option-value').each(function( index ) {
    if($(this).hasClass('active')) {
      variantName = variantName + $(this).attr('data-value');
    }
  });  
  
  
  var variantSelector = '#' + variantName.replace('|','');
  //alert(variantSelector);
  var variantPrice = $(variantSelector).attr('data-price');
  var variantPriceRaw = $(variantSelector).attr('data-price-raw');
  var variantComparedPrice = $(variantSelector).attr('data-price-compare');
  var variantId = $(variantSelector).attr('data-variant');

  /* UPDATE HIDDEN VARIANT INPUT VALUE WITH ID */
  $('#selectedVariant').val(variantId);

  /* UPDATE PRICE DATAS FOR MAIN PRICE DISPLAY AND PURCHASE SCREEN */ 

  /* Main page price display */
  $('#mainPrice').text(variantPrice).attr('data-price',variantPriceRaw);

  if (variantComparedPrice != '0') {
    $('#comparePrice strike').text(variantComparedPrice);    
  } else {
    $('#comparePrice strike').text('');
  }

  /* UPDATE VARIABLE DATAS IN ACCORDIONS */

  /* Images : update images and contents in accordions specificly related to variant if exists */
  $('.variantImgAccordion, .variantTxtAccordion').addClass('hide-content');
  $('.variantImgAccordion[data-variant="' + variantId + '"]').removeClass('hide-content');
  $('.variantTxtAccordion[data-variant="' + variantId + '"]').removeClass('hide-content');


  /* Purchase screens datas */
  $('.btnPrice').text(variantPrice).attr('data-init-price',variantPriceRaw).attr('data-price',variantPriceRaw);
  /* The recalculate price in screens with new variant price and selected options */
  calcProductPrice();  

  /* UPDATE URL WITH SELECTED VARIANT ID */
  const baseUrl = '//' + location.host + location.pathname; 
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search);  

  // Add a third parameter.
  params.set("variant", variantId);
  params.toString(); 
  // Update URL
  window.history.pushState('', '', baseUrl + '?' + params);

}

function variantStock() {

  /* First detect main (first) option selected */
  var mainOption = $('.option-container').first().find('.option-value.active').attr('data-value');

  /* Then loop through variants library */

  $('#variantsLib variant').each(function( index ) {
    /* Only if variant contains main option */
    if ($(this).attr('data-firstOption') == mainOption) {

      /* Build variant options components names */
      var components = $(this).attr('data-options').slice(0,-1).split('|');
      var available = $(this).attr('data-available');
      console.log(components);
      /* Activate or deactivate eahc option depending of availability of variant */
       $.each(components, function( index, value ) {
        if(index > 0) {
          if (available == 'true') {
            $('.option-value[data-value="' + value + '"]').attr('disabled', false).removeClass('hide-content');
          } else {
            $('.option-value[data-value="' + value + '"]').attr('disabled', true).addClass('hide-content');
          }
        }
      });     

    }  
  }); 

} 

/*============================================================================
  INIT
==============================================================================*/
  enableOption();
  listenVariants();
  screenManager();
  choiceListener();
  colorListener();
  preCheckManager();
  priceListener();
  uploadShower();
  cartFormManager();
  choiceListener();
  optionListener();
  screenVariants(); 
  summaryManager(); 